export default __webpack_public_path__ + "static/media/Erectus-10-eng.2af2ccd0.jpg";